import { Badge } from '@chakra-ui/react';

interface Props {
  successPercentage?: number;
}

interface ISuccessBadge {
  color: 'gray' | 'green' | 'yellow';
  value: string;
}

export const SuccessPredictor = ({ successPercentage }: Props) => {
  const getSuccessProps = (): ISuccessBadge => {
    const percentage = `${successPercentage}%`;

    if (successPercentage >= 70) {
      return { color: 'green', value: percentage };
    } else if (successPercentage < 70) {
      return { color: 'yellow', value: percentage };
    }
    return { color: 'gray', value: 'TBD' };
  };

  const { value } = getSuccessProps();

  return (
    <>
      <Badge>{value}</Badge>
    </>
  );
};
